<template>
  <div class="uplimit-promotion-view">
    <div class="promotion-shell">
      <div class="row align-items-center mb-2 px-2">
        <div class="d-flex flex-wrap align-items-center w-100">
        <div class="control-item">
          <b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1" today-button close-button locale="zh"></b-form-datepicker>
        </div>
      </div>
    </div>

      <div v-if="loading" class="text-center text-muted py-3">加载中...</div>
      <div v-else class="promotion-container">
        <div v-for="ban in bans" :key="ban" class="ban-row">
        <!-- 左侧：昨日连板 -->
        <div class="ban-col ban-col-left">
          <div class="ban-header d-flex justify-content-between align-items-center px-2 py-1">
            <span class="ban-title">昨日{{ formatBan(ban) }}({{ getBanStocks(ban).length }})</span>
            <span class="ban-arrow">→</span>
          </div>
          <div class="ban-stocks p-1">
            <div
              v-for="stock in getBanStocks(ban)"
              :key="stock.stock_code"
              class="stock-item mb-1"
              :class="{ 'stock-item-promoted': isPromoted(stock) }"
            >
              <div class="stock-main-row d-flex align-items-center justify-content-between" @click="show_sidebar(stock)" v-b-toggle.sidebar-right-stock>
                <div class="stock-main-left">
                  <div class="stock-title-row">
                    <span class="stock-type-badge mr-1" v-if="stock.up_limit_type">{{ stock.up_limit_type }}</span>
                    <span class="stock-name">{{ stock.stock_name }}</span>
                    <span class="stock-code ml-1">{{ stock.stock_code }}</span>
                    <span v-if="isPromoted(stock)" class="promoted-badge ml-1">晋级</span>
                  </div>
                  <div class="stock-topic-row">
                    <span
                      v-for="topic in getStockPlates(stock)"
                      :key="`${stock.stock_code}-${topic}`"
                      class="stock-topic-tag"
                    >{{ topic }}</span>
                  </div>
                </div>
                <div class="stock-main-right">
                  <span class="stock-time" v-if="stock.up_limit_time">{{ stock.up_limit_time }}</span>
                  <span class="stock-pct" :style="getPctStyle(stock.next_close_pct)">{{ formatPct(stock.next_close_pct) }}</span>
                </div>
            </div>
            </div>
            <div v-if="getBanStocks(ban).length === 0" class="text-center text-muted small py-2">无数据</div>
          </div>
        </div>

        <!-- 右侧：今日晋级 -->
        <div class="ban-col ban-col-right">
          <div class="ban-header d-flex justify-content-between align-items-center px-2 py-1">
            <span class="ban-title">今日{{ formatBan(ban + 1) }}({{ getPromotedStocks(ban).length }})</span>
            <span class="ban-rate-badge">晋级率 {{ getPromotionRate(ban) }}</span>
            <span class="ban-arrow">→</span>
          </div>
          <div class="ban-stocks p-1">
            <div
              v-for="stock in getPromotedStocks(ban)"
              :key="stock.stock_code"
              class="stock-item stock-item-promoted mb-1"
            >
              <div class="stock-main-row d-flex align-items-center justify-content-between" @click="show_sidebar(stock)" v-b-toggle.sidebar-right-stock>
                <div class="stock-main-left">
                  <div class="stock-title-row">
                    <span class="stock-type-badge mr-1" v-if="stock.up_limit_type">{{ stock.up_limit_type }}</span>
                    <span class="stock-name">{{ stock.stock_name }}</span>
                    <span class="stock-code ml-1">{{ stock.stock_code }}</span>
                  </div>
                  <div class="stock-topic-row">
                    <span
                      v-for="topic in getStockPlates(stock)"
                      :key="`${stock.stock_code}-promoted-${topic}`"
                      class="stock-topic-tag"
                    >{{ topic }}</span>
                  </div>
                </div>
                <div class="stock-main-right">
                  <span class="stock-time" v-if="stock.up_limit_time">{{ stock.up_limit_time }}</span>
                  <span class="stock-pct" :style="getPctStyle(stock.next_close_pct)">{{ formatPct(stock.next_close_pct) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="bans.length === 0" class="text-center text-muted py-3">暂无数据</div>
    </div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from "network/request.js"

export default {
  data() {
    const now = new Date();
    const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
    return {
      date1: today,
      last_trade_day: '',
      all_trading_days: [],
      loading: false,
      bans: [],
      stocksByBan: {},
      stockPlateMap: {}
    };
  },
  mounted() {
    request_zzquant({url:'/open/trade/days'}).then(res => {
      let days = res.data.data || [];
      this.all_trading_days = days;
      if (days.length > 0) {
        this.last_trade_day = days[days.length - 1];
        this.date1 = days[days.length - 2] || days[days.length - 1];
        this.update_info(this.date1);
      }
    });
  },
  methods: {
    show_sidebar(stock_info) {
      this.$emit('show_sidebar', stock_info);
    },
    onDatePicked(ctx) {
      this.date1 = ctx.selectedYMD;
      this.update_info(this.date1);
    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      if (this.last_trade_day && ymd === this.last_trade_day) return true;
      if (weekday === 0 || weekday === 6) return true;
      if (date.getTime() >= new Date().getTime()) return true;
      return false;
    },
    update_info(date1) {
      this.loading = true;
      request_zzquant({
        url: 'v3/open/review/uplimit/hot?date1=' + date1
      }).then(res => {
        let data = res.data.data || {};
        this.processData(data);
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    processData(data) {
      const plates = data.plate || [];
      const plateStocks = data.plate_stocks || {};
      
      const mapByBan = {};
      const plateMap = {};

      plates.forEach(item => {
        const plateName = item[0];
        const plateCode = item[1];
        const list = plateStocks[plateCode] || [];
        
        list.forEach(stock => {
          let ban = stock.up_limit_keep_times;
          if (ban === '首') ban = 1;
          if (ban === '炸' || ban === '炸板') return; // Ignore zhaban
          ban = Number(ban);
          if (isNaN(ban) || ban < 1) return;
          
          const code = stock.stock_code;
          if (!code) return;
          
          if (!plateMap[code]) {
            plateMap[code] = [];
          }
          if (plateName && !plateMap[code].includes(plateName)) {
            plateMap[code].push(plateName);
          }

          if (!mapByBan[ban]) mapByBan[ban] = {};
          if (!mapByBan[ban][code]) {
            mapByBan[ban][code] = stock;
          }
        });
      });

      const stocksByBan = {};
      const banLevels = [];
      
      Object.keys(mapByBan).forEach(banStr => {
        const ban = Number(banStr);
        const arr = Object.values(mapByBan[banStr]);
        arr.sort((a, b) => {
          const timeCompare = this.compareTime(a.up_limit_time, b.up_limit_time);
          if (timeCompare !== 0) return timeCompare;
          return String(a.stock_code || '').localeCompare(String(b.stock_code || ''));
        });
        stocksByBan[ban] = arr;
        banLevels.push(ban);
      });

      // Sort ban levels descending
      banLevels.sort((a, b) => b - a);

      this.bans = banLevels;
      this.stocksByBan = stocksByBan;
      this.stockPlateMap = plateMap;
    },
    getBanStocks(ban) {
      return this.stocksByBan[ban] || [];
    },
    getPromotedStocks(ban) {
      const stocks = this.getBanStocks(ban);
      return stocks.filter(s => Number(s.next_close_pct || 0) >= 9.5);
    },
    isPromoted(stock) {
      return Number(stock.next_close_pct || 0) >= 9.5;
    },
    getPromotionRate(ban) {
      const total = this.getBanStocks(ban).length;
      if (total === 0) return '0.0%';
      const promoted = this.getPromotedStocks(ban).length;
      return ((promoted / total) * 100).toFixed(1) + '%';
    },
    getStockPlates(stock) {
      return (this.stockPlateMap[stock.stock_code] || []).slice(0, 2);
    },
    formatBan(ban) {
      return ban === 1 ? '首板' : ban + '连板';
    },
    compareTime(a, b) {
      const fallback = '99:99:99';
      const timeA = (a || fallback).trim();
      const timeB = (b || fallback).trim();
      return timeA.localeCompare(timeB);
    },
    formatPct(val) {
      if (val === undefined || val === null || val === '') return '--';
      const num = Number(val);
      if (isNaN(num)) return '--';
      return (num > 0 ? '+' : '') + num.toFixed(2) + '%';
    },
    getPctStyle(val) {
      const num = Number(val);
      if (isNaN(num)) return { color: '#6c757d' };
      if (num >= 9.5) return { color: '#e33e33', fontWeight: 'bold' };
      if (num > 0) return { color: '#e33e33' };
      if (num < 0) return { color: '#28a745' };
      return { color: '#6c757d' };
    }
  }
}
</script>

<style scoped>
.uplimit-promotion-view {
  overflow-x: hidden;
  padding: 0 8px 10px;
}
.promotion-shell {
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
}
.control-item {
  margin: 3px;
  display: flex;
  align-items: center;
}
.promotion-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ban-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  width: 100%;
}
.ban-col {
  flex: 1;
  min-width: 0;
  border: 1px solid var(--promotion-border);
  border-radius: 5px;
  background: var(--promotion-card-bg);
  box-shadow: 0 2px 8px var(--promotion-shadow);
  display: flex;
  flex-direction: column;
}
.ban-col-left .ban-header {
  background: var(--promotion-header-bg);
  border-bottom: 1px solid var(--promotion-border);
}
.ban-col-right .ban-header {
  background: var(--promotion-header-bg);
  border-bottom: 1px solid var(--promotion-border);
}
.ban-header {
  padding: 4px 8px !important;
}
.ban-title {
  font-weight: bold;
  font-size: 12px;
  color: var(--promotion-title);
}
.ban-arrow {
  color: var(--promotion-muted);
  font-weight: bold;
  font-size: 11px;
}
.ban-rate-badge {
  background: var(--promotion-badge-bg);
  color: var(--promotion-badge-text);
  border: 1px solid var(--promotion-badge-border);
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
}
.stock-item {
  font-size: 12.5px;
  border: 1px solid var(--promotion-item-border);
  border-radius: 4px;
  background: var(--promotion-item-bg);
  color: var(--promotion-text);
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  margin-bottom: 3px !important;
}
.stock-item:hover {
  background: var(--promotion-item-hover-bg);
  border-color: var(--promotion-accent-soft);
  transform: translateY(-1px);
}
.stock-item-promoted {
  background: var(--promotion-success-bg);
  border-color: var(--promotion-success-border);
}
.stock-main-row {
  padding: 4px 6px;
  cursor: pointer;
  gap: 6px;
}
.stock-main-left {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.stock-main-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}
.stock-type-badge {
  background: transparent;
  color: var(--promotion-hot);
  border: 1px solid var(--promotion-hot);
  font-size: 9.5px;
  padding: 0 3px;
  border-radius: 2px;
}
.stock-title-row {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 3px;
}
.stock-name {
  font-weight: 600;
  color: var(--promotion-text-strong);
  font-size: 12.5px;
}
.stock-code {
  font-size: 11px;
  color: var(--promotion-link);
  text-decoration: underline;
  text-underline-offset: 2px;
}
.promoted-badge {
  padding: 0 4px;
  border-radius: 2px;
  font-size: 9px;
  line-height: 13px;
  background: var(--promotion-success-pill-bg);
  color: var(--promotion-success-pill-text);
}
.stock-topic-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 0;
}
.stock-topic-tag {
  font-size: 9.5px;
  line-height: 13px;
  padding: 0 4px;
  border-radius: 2px;
  background: var(--promotion-topic-bg);
  color: var(--promotion-topic-text);
  border: 1px solid var(--promotion-topic-border);
}
.stock-time {
  font-size: 9.5px;
  color: var(--promotion-muted);
  white-space: nowrap;
}
.stock-pct {
  min-width: 55px;
  text-align: right;
  font-weight: bold;
  font-size: 12.5px;
}
@media (max-width: 768px) {
  .uplimit-promotion-view {
    padding: 0 4px 8px;
  }
  .promotion-shell {
    max-width: 100%;
  }
  .ban-row {
    flex-direction: column;
  }
  .ban-col {
    width: 100%;
    border-radius: 4px;
  }
  .ban-header {
    flex-wrap: wrap;
    gap: 4px;
    padding: 3px 6px !important;
  }
  .stock-main-row {
    padding: 4px 6px;
  }
  .stock-main-right {
    min-width: unset;
  }
  .stock-name {
    font-size: 12px;
  }
  .stock-code {
    font-size: 10px;
  }
}
</style>

<style>
.uplimit-promotion-view {
  --promotion-card-bg: rgba(255, 255, 255, 0.92);
  --promotion-header-bg: rgba(243, 246, 252, 0.96);
  --promotion-border: rgba(148, 163, 184, 0.25);
  --promotion-shadow: rgba(15, 23, 42, 0.08);
  --promotion-title: #c47b00;
  --promotion-muted: #64748b;
  --promotion-text: #334155;
  --promotion-text-strong: #0f172a;
  --promotion-link: #2563eb;
  --promotion-item-bg: rgba(255, 255, 255, 0.75);
  --promotion-item-border: rgba(148, 163, 184, 0.18);
  --promotion-item-hover-bg: rgba(239, 246, 255, 0.9);
  --promotion-accent-soft: rgba(96, 165, 250, 0.45);
  --promotion-badge-bg: rgba(245, 158, 11, 0.12);
  --promotion-badge-text: #b45309;
  --promotion-badge-border: rgba(245, 158, 11, 0.35);
  --promotion-topic-bg: rgba(59, 130, 246, 0.08);
  --promotion-topic-text: #1d4ed8;
  --promotion-topic-border: rgba(59, 130, 246, 0.18);
  --promotion-success-bg: linear-gradient(135deg, rgba(254, 243, 199, 0.75), rgba(255, 255, 255, 0.98));
  --promotion-success-border: rgba(245, 158, 11, 0.36);
  --promotion-success-pill-bg: rgba(234, 179, 8, 0.15);
  --promotion-success-pill-text: #a16207;
  --promotion-hot: #dc2626;
}
body.theme-dark .uplimit-promotion-view {
  --promotion-card-bg: rgba(17, 24, 39, 0.92);
  --promotion-header-bg: rgba(30, 41, 59, 0.92);
  --promotion-border: rgba(71, 85, 105, 0.45);
  --promotion-shadow: rgba(2, 6, 23, 0.35);
  --promotion-title: #fbbf24;
  --promotion-muted: #94a3b8;
  --promotion-text: #cbd5e1;
  --promotion-text-strong: #f8fafc;
  --promotion-link: #7dd3fc;
  --promotion-item-bg: rgba(15, 23, 42, 0.72);
  --promotion-item-border: rgba(51, 65, 85, 0.92);
  --promotion-item-hover-bg: rgba(30, 41, 59, 0.92);
  --promotion-accent-soft: rgba(250, 204, 21, 0.35);
  --promotion-badge-bg: rgba(250, 204, 21, 0.12);
  --promotion-badge-text: #fde68a;
  --promotion-badge-border: rgba(250, 204, 21, 0.4);
  --promotion-topic-bg: rgba(59, 130, 246, 0.12);
  --promotion-topic-text: #93c5fd;
  --promotion-topic-border: rgba(96, 165, 250, 0.24);
  --promotion-success-bg: linear-gradient(135deg, rgba(120, 53, 15, 0.32), rgba(30, 41, 59, 0.94));
  --promotion-success-border: rgba(250, 204, 21, 0.34);
  --promotion-success-pill-bg: rgba(250, 204, 21, 0.18);
  --promotion-success-pill-text: #fde68a;
  --promotion-hot: #f87171;
}
</style>
